export {default as ABNANL2A} from './ABNANL2A.svg';
export {default as ASNBNL21} from './ASNBNL21.svg';
export {default as BUNQNL2A} from './BUNQNL2A.svg';
export {default as INGBNL2A} from './INGBNL2A.svg';
export {default as RABONL2U} from './RABONL2U.svg';
export {default as RBRBNL21} from './RBRBNL21.svg';
export {default as SNSBNL2A} from './SNSBNL2A.svg';